import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CashFlowAnalysisService } from '../cash-flow-analysis.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-financial-summary',
    templateUrl: '../cash-flow-analysis.component.html',
    styleUrls: ['../cash-flow-analysis.component.scss'],
    // AK: Automatic change detection seems to be causing mutliple refreshes of iframe containing cash flow summary report
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FinancialSummaryComponent implements OnInit {
  data: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly cashFlowAnalysisService: CashFlowAnalysisService
  ) { }

  ngOnInit() {
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe(data => {
        if (data && data.entity)
          this.getData(data.entity.id);
      });
  }

  getData(entityId: number): void {
    this.cashFlowAnalysisService.getFinancialSummary(entityId)
      .subscribe(data => {
        this.data = data;
        // AK: Refresh component to show iframe if there is data
        this.changeDetector.markForCheck();
      });
  }

}
